<template>
    <b-row>
        <b-col cols="12">
            <h3>{{ $t('evento.titulo_voucher') }}</h3>

            <div class="input-group">
                <input class="form-control w-auto" id="input-voucher" v-model="code" :placeholder="$t('formularios.cupon_descuento')" :disabled="(message && !error) || desactivar" />
                <Button
                    v-if="message && !error"
                    :label="'Quitar'"
                    :disabled="desactivar"
                    @click="remove"
                />
                <Button
                    v-else
                    :label="$t('formularios.verificar')"
                    :disabled="desactivar || loading || loading_check || !code"
                    @click="check"
                />
            </div>

            <input class="form-control is-invalid" hidden />
            <span :class="{error: true, 'bg-success': !error}" v-if="message">{{ message }}</span>
        </b-col>
        <b-col cols="12" class="mt-3">
            <Button
                :label="$t('formularios.continuar_sin_cupon')"
                :disabled="(message && !error) || desactivar || loading || loading_check"
                @click="continuar"
            />
            <Button
                :label="$t('formularios.atras')"
                :disabled="(message && !error) || desactivar || loading || loading_check"
                custom-class="ml-2"
                @click="volver"
            />
        </b-col>
    </b-row>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import  store  from '@/store';
    import { config } from '@/config.js';
    import Button from '@/modules/ui/Button.vue';

    const props = defineProps({
        sesion_id: {
            type: String,
            required: true
        },
        datos: {
            type: Array,
            required: true
        },
        desactivar: {
            type: Boolean,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    });

    const emit = defineEmits(['continuar', 'volver']);

    const code = ref(null);
    const message = ref(null);
    const error = ref(false);
    const loading_check = ref(false);

    const configuracion = computed(() => store.getters.getConfig);
    const lista_abonados = computed(() => store.getters.getListaAbonados);

    const remove = () => {
        code.value = null;
        message.value = null;
    };

    const check = () => {
        loading_check.value = true;

        const data = {
            filters: {
                tid: configuracion.value.hash_teatro,
                lista_id: lista_abonados.value.id
            },
            sesion_id: props.sesion_id,
            code: code.value,
            datos: props.datos
        };

        store.dispatch(config.getVuexAlias('front.abonados.compra.voucher'), data)
            .then(res => {
                message.value = res.data.message;
                error.value = false;
                continuar();
            })
            .catch(err => {
                message.value = err.response.data.message;
                error.value = true;
            })
            .finally(() => {
                loading_check.value = false;
            });
    };

    const continuar = () => {
        emit('continuar');
    };

    const volver = () => {
        emit('volver');
    };
</script>
